<template>
  <div>
    <select :class="`form-select ${enterToTab? 'EnterToTab' : ''}`" v-enter-to-tab="enterToTab" v-model="selectedOption"
            :disabled="disabled" @change="onSelected">
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "AppSelect",
  props: {
    /* The structure of each option is: 
      {
        value: 'value',
        text: 'Display text'
      }
    */
    initialValue: {
     type: String,
     required: false,
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    enterToTab: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selectedOption: null
    }
  },
  methods: {
    onSelected(event) {
      this.selectedOption = event.target.value;
      this.$emit('onSelected', this.selectedOption);
    },
  },
  created() {
    this.selectedOption = this.initialValue;
  }
}
</script>

<style scoped>
.form-select {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #4c4d57;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>